/**
 * Odroczone „sprawdź, czy profil jeszcze istnieje”. Rodzic mógł usunąć profil, zarchiwizować go, wyłączyć urządzenie albo cofnąć zgodę na nagrania — aplikacja ma wtedy
 * odświeżyć profil (`refresh`) i, jeśli już go nie ma, wyjść do ekranu wyboru (`leave`). Ale na ekranie lekcji niczego nie przerywamy: odświeżenie, które kończy sesję,
 * zmienia motyw i zeruje postęp w środku ćwiczenia. Dlatego poza ekranem głównym prośba tylko się zapamiętuje, a robi się ją przy powrocie na ekran główny (`take`).
 */
export interface ExitGate {
  /** Ekran główny: odświeża od razu (i wychodzi, gdy profilu już nie ma). Gdzie indziej (lekcja, ustawienia): zapamiętuje prośbę. */
  request(): void;
  /** Zwraca, czy była zapamiętana prośba, i ją zeruje — woła ekran główny przy wejściu. */
  take(): boolean;
}

export function createExitGate(deps: { atHome: () => boolean; refresh: () => Promise<boolean>; leave: () => void }): ExitGate {
  let pending = false;
  return {
    request() {
      if (deps.atHome()) void deps.refresh().then((ok) => (ok ? undefined : deps.leave())).catch(() => undefined);
      else pending = true;
    },
    take() {
      const was = pending;
      pending = false;
      return was;
    },
  };
}
